import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';

import {
  GetChatEvents,
  IChatEvent,
  GetChatEventsResponse
} from '../../../libs/chat';
import Modal from '../modal';
import Pagination from '../pagination';

interface ChatHistoryProps {
  patientId: number;
}

const ChatHistory = ({ patientId }: ChatHistoryProps): JSX.Element => {
  const [events, setEvents] = useState<IChatEvent[]>([]);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const PAGE_LIMIT = 20;

  const loadEvents = useCallback(
    (pageToLoad: number) => {
      setIsLoading(true);
      GetChatEvents({
        patientId,
        page: pageToLoad,
        limit: PAGE_LIMIT
      }).then((response) => {
        setIsLoading(false);
        if (response.status === 'FAIL') {
          Modal.error({
            title: 'Error Loading History',
            content: response.message
          });
          return;
        }
        const data = response as GetChatEventsResponse;
        const newEvents = data.events.map((e) => ({
          ...e,
          createdAt: new Date(e.createdAt)
        }));
        setEvents(newEvents);
        setTotal(data.total);
      });
    },
    [patientId]
  );

  useEffect(() => {
    setPage(0);
    loadEvents(0);
  }, [loadEvents]);

  const handlePageChange = (newPage: number) => {
    const pageIndex = newPage - 1;
    setPage(pageIndex);
    loadEvents(pageIndex);
  };

  return (
    <div className="pa-4">
      {events.map((event) => (
        <div key={event.id} className="mb-4 pb-4 border-b border-light-grey">
          <div className="text-small text-gray3 mb-1">
            {moment(event.createdAt).format('MMM D, YYYY h:mm A')}
          </div>
          <div className="font-bold">{event.description}</div>
          {event.user && (
            <div className="text-small mt-1">by {event.user.email}</div>
          )}
        </div>
      ))}
      <div className="mt-4 flex justify-center">
        <Pagination
          page={page + 1}
          total={total}
          limit={PAGE_LIMIT}
          isDisabled={isLoading}
          onPageChange={handlePageChange}
        />
      </div>
      {events.length === 0 && !isLoading && (
        <div className="text-center text-gray3 mt-8">
          No history events found.
        </div>
      )}
    </div>
  );
};

export default ChatHistory;
